import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-vacancy-process-modal',
  templateUrl: './vacancy-process-modal.component.html',
  styleUrls: ['./vacancy-process-modal.component.scss']
})
export class VacancyProcessModalComponent implements OnInit {

  @Input() vacancy: any = null;

  @Output() onClose: EventEmitter<any> = new EventEmitter<any>(); 
  @Output() onProcessComplete: EventEmitter<any> = new EventEmitter<any>(); 

  public isLoading: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  close(){
    this.onClose.emit(null);
  }

  processComplete(){
    this.onProcessComplete.emit(this.vacancy);
  }
}
